/**
 * The UTF8 field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const UTF8 = 'utf8';
